import React from "react";
import * as PropTypes from "prop-types";
import FormatMessage from "../../messages/FormatMessage";
import dot from "dot-object";
import LearnMore_LightBox from "./LearnMore_LightBox";
import $ from 'jquery'

class Country extends React.Component {

    static propTypes = {
        property: PropTypes.string,
        beanName: PropTypes.string,
        required: PropTypes.string,
        labelKey: PropTypes.string,
        otherTextMask: PropTypes.string,
        otherTextMaskKey: PropTypes.string,
        otherTextHeaderKey: PropTypes.string,
        errorKey: PropTypes.string,
        otherTextErrorKey: PropTypes.string,
        requireOptional: PropTypes.string,
        requireExplain: PropTypes.string,
        withoutUS: PropTypes.string,
        stateId: PropTypes.string,
        onChange: PropTypes.string,
        subLabel: PropTypes.string,
        subLabelKey: PropTypes.string,
        linkToPageID: PropTypes.string,
        id: PropTypes.string,
        requireOtherOption: PropTypes.string,
        controlInsideAddress: PropTypes.string,
        controlInsideRepeater: PropTypes.string,
        controlAsRepeater: PropTypes.string,
        instructionText: PropTypes.string,
        instructionExplain: PropTypes.string,
        repeaterShowHide: PropTypes.string,
        requireLightBox: PropTypes.string,
        pageid: PropTypes.string,
        hasLearnMoreHeader: PropTypes.string,
        repeaterCountKey: PropTypes.string,
        state: PropTypes.string,
        status: PropTypes.string
    }
    static defaultProps = {
        property: '',
        beanName: '',
        required: '',
        labelKey: '',
        otherTextMask: '',
        otherTextMaskKey: '',
        otherTextHeaderKey: '',
        errorKey: '',
        otherTextErrorKey: '',
        requireOptional: '',
        requireExplain: '',
        withoutUS: '',
        stateId: '',
        onChange: '',
        subLabel: '',
        subLabelKey: '',
        linkToPageID: '',
        id: '',
        requireOtherOption: '',
        controlInsideAddress: '',
        controlInsideRepeater: '',
        controlAsRepeater: '',
        instructionText: '',
        instructionExplain: '',
        repeaterShowHide: '',
        requireLightBox: '',
        pageid: '',
        hasLearnMoreHeader: '',
        repeaterCountKey: '',
        state: '',
        status: ''
    }

    constructor(props) {
        super(props);
        this.state = {
            ddmVal: "",
            otherCountryValue: "",
            isOtherCountry: false,
            showModal: false,
            application: {}
        }
        this.handleDDMChange = this.handleDDMChange.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.application != prevState.application) {
            let country = dot.pick(nextProps.property, nextProps.application.applicationData)
            let isOtherCountry = prevState.isOtherCountry
            let otherCountryValue = prevState.otherCountryValue
            if (country != undefined && country != "" && !isOtherCountry) {
                let countries = []
                let dynamicId = nextProps.beanName + "-" + nextProps.property.replace(/\./g, '-');
                $('#' + dynamicId + ' option').each(function () {
                    countries.push($(this).val())
                });
                if (!countries.includes(country)) {
                    //isOtherCountry = true
                    otherCountryValue = country
                }
            }
            return {
                application: nextProps.application,
                ddmVal: prevState.isOtherCountry ? "Other" : country,
                isOtherCountry: isOtherCountry,
                otherCountryValue: otherCountryValue
            }
        }

        return null;
    }

    render() {
        const {
            property,
            beanName,
            required,
            labelKey,
            otherTextHeaderKey,
            errorKey,
            otherTextErrorKey,
            requireOptional,
            requireExplain,
            withoutUS,
            subLabelKey,
            requireOtherOption,
            controlInsideAddress,
            controlAsRepeater,
            instructionText,
            repeaterShowHide,
            requireLightBox,
            pageid,
            repeaterCountKey,
            state,
            status
        } = this.props;
        var dynamicId = beanName + "-" + property.replace(/\./g, '-');
        return (
            <div className={controlAsRepeater == "" && repeaterShowHide == "" ? "QuestionSection" : ""}>
                {state == undefined || state == "" &&
                    <div>
                        {controlInsideAddress == "" &&
                            <div className="Question">
                                <div className="Question-title">
	                                <span className="Question-titleText">
                                        {labelKey != "" &&
                                            <FormatMessage id={labelKey}/>
                                        }
                                        {labelKey == "" &&
                                            <FormatMessage id="control.address.country"/>
                                        }
                                    </span>
                                    {(requireExplain == 'header' || requireLightBox != "") &&
                                        <a className="LearnMoreLink" onClick={() => this.handleShowModal()}>
                                            <FormatMessage id="control.explain"/>
                                        </a>
                                    }
                                </div>
                                {instructionText != "" &&
                                    <div className="Question-instructions">
                                        <FormatMessage id={instructionText}/>
                                        {requireLightBox == 'instructiontext' &&
                                            <a className="LearnMoreLink" onClick={() => this.handleShowModal()}>
                                                <FormatMessage id="control.explain"/>
                                            </a>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        {controlAsRepeater != "" &&
                            <div className="FixedLayout ElementRepeater-header">
                                <div className="FixedLayoutMain ElementRepeater-headerMain">
                                    <div className="ElementRepeater-headerLabel">
                                        <FormatMessage id="Country_name_counts"/>
                                    </div>
                                </div>
                                <div className="FixedLayoutAside ElementRepeater-headerAside">
                                </div>
                            </div>
                        }
                        <div className={controlAsRepeater != "" ? "ElementRepeater-main" : ""}>
                            <div className="AnswerField set">
                                {controlInsideAddress != "" &&
                                    <label className="AnswerField-label" htmlFor={dynamicId + "-country"}>
                                        {labelKey != "" &&
                                            <FormatMessage id={labelKey}/>
                                        }
                                        {labelKey == "" &&
                                            <FormatMessage id="control.address.country"/>
                                        }
                                        {requireOptional != "" &&
                                            <div className="AnswerField-optionLabel">
                                                <FormatMessage id="control.requireOptional"/>
                                            </div>
                                        }
                                        {(requireExplain == 'header' || requireLightBox != "") &&
                                            <a className="LearnMoreLink" onClick={() => this.handleShowModal()}>
                                                <FormatMessage id="control.explain"/>
                                            </a>
                                        }
                                    </label>
                                }
                                <div className="GridLayout AnswerField-layout">
                                    <div className="AnswerField-cell element">
                                        <div className="SelectInput SelectInput-fixedWidth">
                                            {subLabelKey != "" &&
                                                <div className="AnswerField-subLabel">
                                                    <FormatMessage id={subLabelKey}/>
                                                </div>
                                            }
                                            <select name={dynamicId} id={dynamicId} value={this.state.ddmVal}
                                                    onChange={(e) => this.handleDDMChange(e, property)}
                                                    data-msg-required={errorKey != "" ? errorKey : "error.control.common"}
                                                    data-rule-required={required}>
                                                <option value=""></option>
                                                {withoutUS == "" &&
                                                    <FormatMessage id="control.country.unitedstatesofamerica">
                                                        {(message) => <option
                                                            value="United States of America">{message}</option>}
                                                    </FormatMessage>
                                                }
                                                <FormatMessage id="control.country.afghanistan">
                                                    {(message) => <option value="Afghanistan">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.albania">
                                                    {(message) => <option value="Albania">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.algeria">
                                                    {(message) => <option value="Algeria">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.andorra">
                                                    {(message) => <option value="Andorra">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.angola">
                                                    {(message) => <option value="Angola">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.antiguaandbarbuda">
                                                    {(message) => <option
                                                        value="Antigua and Barbuda">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.argentina">
                                                    {(message) => <option value="Argentina">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.armenia">
                                                    {(message) => <option value="Armenia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.australia">
                                                    {(message) => <option value="Australia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.austria">
                                                    {(message) => <option value="Austria">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.azerbaijan">
                                                    {(message) => <option value="Azerbaijan">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.bahamasthe">
                                                    {(message) => <option value="Bahamas, The">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.bahrain">
                                                    {(message) => <option value="Bahrain">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.bangladesh">
                                                    {(message) => <option value="Bangladesh">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.barbados">
                                                    {(message) => <option value="Barbados">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.belarus">
                                                    {(message) => <option value="Belarus">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.belgium">
                                                    {(message) => <option value="Belgium">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.belize">
                                                    {(message) => <option value="Belize">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.benin">
                                                    {(message) => <option value="Benin">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.bhutan">
                                                    {(message) => <option value="Bhutan">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.bolivia">
                                                    {(message) => <option value="Bolivia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.bosniaandherzegovina">
                                                    {(message) => <option
                                                        value="Bosnia and Herzegovina">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.botswana">
                                                    {(message) => <option value="Botswana">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.brazil">
                                                    {(message) => <option value="Brazil">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.brunei">
                                                    {(message) => <option value="Brunei">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.bulgaria">
                                                    {(message) => <option value="Bulgaria">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.burkinafaso">
                                                    {(message) => <option value="Burkina Faso">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.burma">
                                                    {(message) => <option value="Burma">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.burundi">
                                                    {(message) => <option value="Burundi">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.cambodia">
                                                    {(message) => <option value="Cambodia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.cameroon">
                                                    {(message) => <option value="Cameroon">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.canada">
                                                    {(message) => <option value="Canada">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.capeverde">
                                                    {(message) => <option value="Cape Verde">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.centralafricanrepublic">
                                                    {(message) => <option
                                                        value="Central African Republic">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.chad">
                                                    {(message) => <option value="Chad">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.chile">
                                                    {(message) => <option value="Chile">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.china">
                                                    {(message) => <option value="China">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.colombia">
                                                    {(message) => <option value="Colombia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.comoros">
                                                    {(message) => <option value="Comoros">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.congobrazzaville">
                                                    {(message) => <option
                                                        value="Congo (Brazzaville)">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.congokinshasa">
                                                    {(message) => <option value="Congo (Kinshasa)">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.costarica">
                                                    {(message) => <option value="Costa Rica">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.cotedivoire">
                                                    {(message) => <option value="Cote d Ivoire">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.croatia">
                                                    {(message) => <option value="Croatia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.cuba">
                                                    {(message) => <option value="Cuba">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.cyprus">
                                                    {(message) => <option value="Cyprus">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.czechrepublic">
                                                    {(message) => <option value="Czech Republic">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.denmark">
                                                    {(message) => <option value="Denmark">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.djibouti">
                                                    {(message) => <option value="Djibouti">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.dominica">
                                                    {(message) => <option value="Dominica">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.dominicanrepublic">
                                                    {(message) =>
                                                        <option
                                                            value="Dominican Republic">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.ecuador">
                                                    {(message) => <option value="Ecuador">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.egypt">
                                                    {(message) => <option value="Egypt">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.elsalvador">
                                                    {(message) => <option value="El Salvador">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.equatorialguinea">
                                                    {(message) =>
                                                        <option
                                                            value="Equatorial Guinea">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.eritrea">
                                                    {(message) => <option value="Eritrea">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.estonia">
                                                    {(message) => <option value="Estonia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.ethiopia">
                                                    {(message) => <option value="Ethiopia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.fiji">
                                                    {(message) => <option value="Fiji">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.finland">
                                                    {(message) => <option value="Finland">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.france">
                                                    {(message) => <option value="France">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.gabon">
                                                    {(message) => <option value="Gabon">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.gambiathe">
                                                    {(message) => <option value="Gambia, The">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.georgia">
                                                    {(message) => <option value="Georgia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.germany">
                                                    {(message) => <option value="Germany">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.ghana">
                                                    {(message) => <option value="Ghana">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.greece">
                                                    {(message) => <option value="Greece">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.grenada">
                                                    {(message) => <option value="Grenada">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.guatemala">
                                                    {(message) => <option value="Guatemala">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.guinea">
                                                    {(message) => <option value="Guinea">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.guinea-bissau">
                                                    {(message) => <option value="Guinea-Bissau">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.guyana">
                                                    {(message) => <option value="Guyana">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.haiti">
                                                    {(message) => <option value="Haiti">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.holysee">
                                                    {(message) => <option value="Holy See">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.honduras">
                                                    {(message) => <option value="Honduras">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.hongkongsar">
                                                    {(message) => <option value="Hong Kong SAR">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.hungary">
                                                    {(message) => <option value="Hungary">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.iceland">
                                                    {(message) => <option value="Iceland">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.india">
                                                    {(message) => <option value="India">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.indonesia">
                                                    {(message) => <option value="Indonesia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.iran">
                                                    {(message) => <option value="Iran">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.iraq">
                                                    {(message) => <option value="Iraq">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.irelandnorthern">
                                                    {(message) => <option value="Ireland, Northern">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.irelandrepublicof">
                                                    {(message) => <option
                                                        value="Ireland, Republic of">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.israel">
                                                    {(message) => <option value="Israel">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.italy">
                                                    {(message) => <option value="Italy">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.jamaica">
                                                    {(message) => <option value="Jamaica">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.japan">
                                                    {(message) => <option value="Japan">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.jordan">
                                                    {(message) => <option value="Jordan">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.kazakhstan">
                                                    {(message) => <option value="Kazakhstan">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.kenya">
                                                    {(message) => <option value="Kenya">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.kiribati">
                                                    {(message) => <option value="Kiribati">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.korea.north">
                                                    {(message) => <option value="Korea, North">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.korea.south">
                                                    {(message) => <option value="Korea, South">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.kosovo">
                                                    {(message) => <option value="Kosovo">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.kuwait">
                                                    {(message) => <option value="Kuwait">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.kyrgyzstan">
                                                    {(message) => <option value="Kyrgyzstan">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.laos">
                                                    {(message) => <option value="Laos">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.latvia">
                                                    {(message) => <option value="Latvia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.lebanon">
                                                    {(message) => <option value="Lebanon">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.lesotho">
                                                    {(message) => <option value="Lesotho">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.liberia">
                                                    {(message) => <option value="Liberia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.libya">
                                                    {(message) => <option value="Libya">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.liechtenstein">
                                                    {(message) => <option value="Liechtenstein">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.lithuania">
                                                    {(message) => <option value="Lithuania">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.luxembourg">
                                                    {(message) => <option value="Luxembourg">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.macausar">
                                                    {(message) => <option value="Macau SAR">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.macedonia">
                                                    {(message) => <option value="Macedonia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.madagascar">
                                                    {(message) => <option value="Madagascar">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.malawi">
                                                    {(message) => <option value="Malawi">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.malaysia">
                                                    {(message) => <option value="Malaysia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.maldives">
                                                    {(message) => <option value="Maldives">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.mali">
                                                    {(message) => <option value="Mali">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.malta">
                                                    {(message) => <option value="Malta">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.marshallislands">
                                                    {(message) => <option value="Marshall Islands">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.mauritania">
                                                    {(message) => <option value="Mauritania">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.mauritius">
                                                    {(message) => <option value="Mauritius">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.mexico">
                                                    {(message) => <option value="Mexico">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.micronesia">
                                                    {(message) => <option value="Micronesia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.moldova">
                                                    {(message) => <option value="Moldova">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.monaco">
                                                    {(message) => <option value="Monaco">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.mongolia">
                                                    {(message) => <option value="Mongolia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.montenegro">
                                                    {(message) => <option value="Montenegro">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.morocco">
                                                    {(message) => <option value="Morocco">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.mozambique">
                                                    {(message) => <option value="Mozambique">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.namibia">
                                                    {(message) => <option value="Namibia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.nauru">
                                                    {(message) => <option value="Nauru">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.nepal">
                                                    {(message) => <option value="Nepal">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.netherlands">
                                                    {(message) => <option value="Netherlands">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.netherlandsantilles">
                                                    {(message) => <option
                                                        value="Netherlands Antilles">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.newzealand">
                                                    {(message) => <option value="New Zealand">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.nicaragua">
                                                    {(message) => <option value="Nicaragua">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.niger">
                                                    {(message) => <option value="Niger">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.nigeria">
                                                    {(message) => <option value="Nigeria">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.norway">
                                                    {(message) => <option value="Norway">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.oman">
                                                    {(message) => <option value="Oman">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.pakistan">
                                                    {(message) => <option value="Pakistan">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.palau">
                                                    {(message) => <option value="Palau">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.panama">
                                                    {(message) => <option value="Panama">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.papuanewguinea">
                                                    {(message) => <option value="Papua New Guinea">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.paraguay">
                                                    {(message) => <option value="Paraguay">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.peru">
                                                    {(message) => <option value="Peru">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.philippines">
                                                    {(message) => <option value="Philippines">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.poland">
                                                    {(message) => <option value="Poland">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.portugal">
                                                    {(message) => <option value="Portugal">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.qatar">
                                                    {(message) => <option value="Qatar">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.romania">
                                                    {(message) => <option value="Romania">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.russia">
                                                    {(message) => <option value="Russia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.rwanda">
                                                    {(message) => <option value="Rwanda">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.saintkittsandnevis">
                                                    {(message) => <option
                                                        value="Saint Kitts and Nevis">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.saintlucia">
                                                    {(message) => <option value="Saint Lucia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.saintvincentandthegrenadines">
                                                    {(message) => <option
                                                        value="Saint Vincent and the Grenadines">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.samoa">
                                                    {(message) => <option value="Samoa">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.sanmarino">
                                                    {(message) => <option value="San Marino">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.saotomeandprincipe">
                                                    {(message) => <option
                                                        value="Sao Tome and Principe">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.saudiarabia">
                                                    {(message) => <option value="Saudi Arabia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.senegal">
                                                    {(message) => <option value="Senegal">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.serbia">
                                                    {(message) => <option value="Serbia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.seychelles">
                                                    {(message) => <option value="Seychelles">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.sierraleone">
                                                    {(message) => <option value="Sierra Leone">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.singapore">
                                                    {(message) => <option value="Singapore">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.slovakia">
                                                    {(message) => <option value="Slovakia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.slovenia">
                                                    {(message) => <option value="Slovenia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.solomonislands">
                                                    {(message) => <option value="Solomon Islands">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.somalia">
                                                    {(message) => <option value="Somalia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.southafrica">
                                                    {(message) => <option value="South Africa">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.spain">
                                                    {(message) => <option value="Spain">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.srilanka">
                                                    {(message) => <option value="Sri Lanka">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.southsudan">
                                                    {(message) => <option value="South Sudan">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.sudan">
                                                    {(message) => <option value="Sudan">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.suriname">
                                                    {(message) => <option value="Suriname">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.swaziland">
                                                    {(message) => <option value="Swaziland">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.sweden">
                                                    {(message) => <option value="Sweden">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.switzerland">
                                                    {(message) => <option value="Switzerland">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.syria">
                                                    {(message) => <option value="Syria">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.taiwan">
                                                    {(message) => <option value="Taiwan">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.tajikistan">
                                                    {(message) => <option value="Tajikistan">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.tanzania">
                                                    {(message) => <option value="Tanzania">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.thailand">
                                                    {(message) => <option value="Thailand">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.timorlesteeasttimor">
                                                    {(message) => <option
                                                        value="Timor-Leste (East Timor)">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.togo">
                                                    {(message) => <option value="Togo">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.tonga">
                                                    {(message) => <option value="Tonga">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.trinidadandtobago">
                                                    {(message) => <option
                                                        value="Trinidad and Tobago">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.tunisia">
                                                    {(message) => <option value="Tunisia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.turkey">
                                                    {(message) => <option value="Turkey">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.turkmenistan">
                                                    {(message) => <option value="Turkmenistan">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.tuvalu">
                                                    {(message) => <option value="Tuvalu">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.uganda">
                                                    {(message) => <option value="Uganda">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.ukraine">
                                                    {(message) => <option value="Ukraine">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.unitedarabemirates">
                                                    {(message) => <option
                                                        value="United Arab Emirates">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.unitedkingdom">
                                                    {(message) => <option value="United Kingdom">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.uruguay">
                                                    {(message) => <option value="Uruguay">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.uzbekistan">
                                                    {(message) => <option value="Uzbekistan">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.vanuatu">
                                                    {(message) => <option value="Vanuatu">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.venezuela">
                                                    {(message) => <option value="Venezuela">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.vietnam">
                                                    {(message) => <option value="Vietnam">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.yemen">
                                                    {(message) => <option value="Yemen">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.zambia">
                                                    {(message) => <option value="Zambia">{message}</option>}
                                                </FormatMessage>
                                                <FormatMessage id="control.country.zimbabwe">
                                                    {(message) => <option value="Zimbabwe">{message}</option>}
                                                </FormatMessage>
                                                {requireOtherOption != "" &&
                                                    <FormatMessage id="control.country.other">
                                                        {(message) => <option value="Other">{message}</option>}
                                                    </FormatMessage>
                                                }
                                            </select>
                                            {requireOptional != "" &&
                                                <div className="AnswerField-optionLabel">
                                                    <FormatMessage id="control.requireOptional"/>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <p className="AnswerField-errorMessage"></p>
                            </div>
                            {this.state.isOtherCountry &&
                                <div className="AnswerField set">
                                    <label className="AnswerField-label">
                                        <FormatMessage id={otherTextHeaderKey}/>
                                    </label>
                                    <div className="GridLayout AnswerField-layout">
                                        <div className="GridLayoutCell AnswerField-cell element">
                                            <div className="TextInput TextInput-fixedWidth">
                                                <input type="text"
                                                       id={dynamicId + "-countryothertext"}
                                                       name={dynamicId + "-countryothertext"}
                                                       onChange={(e) => this.handleInputChange(e, property)}
                                                       defaultValue={this.state.otherCountryValue}
                                                       data-msg-required={otherTextErrorKey != "" ? otherTextErrorKey : "control.text.mandatoryerror"}
                                                       data-rule-required={required}/>
                                            </div>
                                        </div>
                                    </div>
                                    <p className="AnswerField-errorMessage"></p>
                                </div>
                            }
                        </div>
                        {this.state.showModal &&
                            <LearnMore_LightBox contentKey={"explainthis." + pageid}
                                                handleOpenModal={() => this.handleShowModal()}/>
                        }
                    </div>
                }
                {state != undefined && state == "output" &&
                    <div>
                        {this.props.repeaterIndex != undefined ?
                            <div>
                                <div className="ReviewSection-elementRepeaterHeader">
                                    <span className="ReviewSection-elementRepeaterHeaderLabel">
                                        <FormatMessage id={repeaterCountKey}/> {this.props.repeaterIndex + 1}
                                    </span>
                                </div>
                                <div className="ReviewSection-elementRepeaterMain">
                                    <div className="ReviewSection-elementRepeaterField">
                                        {!required ?
                                            <div
                                                className="ReviewSection-elementRepeaterAnswer ReviewSection-answerLabelOptional">
                                                <FormatMessage id="message.optionfield"/>
                                            </div> :
                                            status == "incomplete" ?
                                                <div className="ReviewSection-elementRepeaterAnswer">
                                                    <div className="ReviewAnswerStatus ReviewAnswerStatus-incomplete">
                                                <span className="ReviewAnswerStatus-label">
                                                    <FormatMessage id="application.sectionreview.incomplete"/>
                                                </span>
                                                    </div>
                                                </div> :
                                                <div className="ReviewSection-elementRepeaterAnswer">
                                                    {this.state.ddmVal != undefined && this.state.ddmVal != "" ? this.state.ddmVal != "Other" ? this.state.ddmVal : this.state.otherCountryValue : ""}
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div> :
                            !required ?
                                <div className="ReviewSection-answerLabelOptional">
                                    <FormatMessage id="message.optionfield"/>
                                </div> :
                                status == "incomplete" ?
                                    <div className="ReviewAnswerStatus ReviewAnswerStatus-incomplete">
                                        <span className="ReviewAnswerStatus-label">
                                            <FormatMessage id="application.sectionreview.incomplete"/>
                                        </span>
                                    </div> :
                                    <div className="ReviewSection-answer">
                                        <span className="ReviewSection-answerLabel">
                                            {this.state.ddmVal != undefined && this.state.ddmVal != "" ? this.state.ddmVal != "Other" ? this.state.ddmVal : this.state.otherCountryValue : ""}
                                        </span>
                                    </div>
                        }
                    </div>
                }
            </div>
        )
    }

    handleShowModal() {
        this.setState({
            showModal: !this.state.showModal
        })
    }

    handleDDMChange(event, property) {
        let value = event.target.value
        this.setState({
            ddmVal: value,
            isOtherCountry: value == "Other" ? true : false,
            otherCountryValue: ""
        })
        const applicationData = this.state.application.applicationData;
        applicationData[property] = value
        dot.object(applicationData);
        this.props.dispatchApplicationData(applicationData)
    }

    handleInputChange(event, property) {
        let value = event.target.value
        this.setState({
            otherCountryValue: value
        })
        const applicationData = this.state.application.applicationData;
        applicationData[property] = value
        dot.object(applicationData);
        this.props.dispatchApplicationData(applicationData)
    }
}

export default Country;